import {
  FiCalendar,
  FiCheckCircle,
  FiClock,
  FiXCircle,
} from "react-icons/fi";

const icons = {
  "Pending Requests": FiClock,
  Approved: FiCheckCircle,
  Rejected: FiXCircle,
  "On Leave Today": FiCalendar,
};

const colors = {
  "Pending Requests": "bg-yellow-100 text-yellow-600",
  Approved: "bg-green-100 text-green-600",
  Rejected: "bg-red-100 text-red-600",
  "On Leave Today": "bg-blue-100 text-blue-600",
};

export default function LeaveStats({ title, count }) {
  const Icon = icons[title] || FiCalendar;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-500">{title}</p>

          <h2 className="mt-2 text-3xl font-bold text-gray-900">
            {count ?? 0}
          </h2>
        </div>

        <div
          className={`h-14 w-14 rounded-2xl flex items-center justify-center ${
            colors[title] || "bg-gray-100 text-gray-600"
          }`}
        >
          <Icon size={24} />
        </div>
      </div>
    </div>
  );
}